var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnoDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 186,
    viewBox: "0 0 614 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.13512,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.3751,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.2551,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.3751,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.6151,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.7351,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.2151,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.2151,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.575,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.815,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.695,
    cy: 133.48,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.575,
    cy: 123.36,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.815,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.815,
    cy: 123.36,
    r: 1.265,
    fill: "#9796F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.815,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.935,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.415,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.415,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.295,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.415,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 143.6,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.775,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.655,
    cy: 143.6,
    r: 1.265,
    fill: "#A7F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.775,
    cy: 143.6,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 133.48,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.775,
    cy: 123.36,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 123.36,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.775,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.775,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.415,
    cy: 82.88,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.295,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.415,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.415,
    cy: 52.52,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.535,
    cy: 52.52,
    r: 1.265,
    fill: "#A7F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.655,
    cy: 52.52,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 72.76,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.015,
    cy: 12.04,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.015,
    cy: 22.16,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 32.28,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 42.4,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.015,
    cy: 52.52,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.135,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.015,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.255,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.375,
    cy: 62.64,
    r: 1.265,
    fill: "#A7F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.135,
    cy: 32.28,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.135,
    cy: 22.16,
    r: 1.265,
    fill: "#A7F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.255,
    cy: 22.16,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.265,
    cy: 1.92003,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.265,
    cy: 42.4,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.385,
    cy: 52.52,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.505,
    cy: 52.52,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.505,
    cy: 42.4,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.505,
    cy: 32.28,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.505,
    cy: 22.16,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.625,
    cy: 12.04,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.745,
    cy: 1.92003,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.745,
    cy: 12.04,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.865,
    cy: 1.92003,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.985,
    cy: 12.04,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.865,
    cy: 32.28,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.745,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.865,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.105,
    cy: 52.52,
    r: 1.265,
    fill: "#FBB979"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.225,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.345,
    cy: 72.76,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.985,
    cy: 82.88,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.105,
    cy: 82.88,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.225,
    cy: 82.88,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.105,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.105,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.225,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.345,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.465,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.705,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.585,
    cy: 72.76,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.585,
    cy: 62.64,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.705,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.585,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.225,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.225,
    cy: 123.36,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.105,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.105,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.105,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.225,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.345,
    cy: 143.6,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.465,
    cy: 143.6,
    r: 1.265,
    fill: "#FBB979"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.585,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.705,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.585,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.465,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.465,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.585,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.185,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.305,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.425,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.425,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.305,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.185,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.185,
    cy: 143.6,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.545,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510.665,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.545,
    cy: 153.72,
    r: 1.265,
    fill: "#96BAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.305,
    cy: 133.48,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.785,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.905,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 571.385,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.625,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.625,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.745,
    cy: 173.96,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.865,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.265,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.785,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.425,
    cy: 123.36,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.185,
    cy: 123.36,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.065,
    cy: 113.24,
    r: 1.265,
    fill: "#96BAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.185,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.545,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.185,
    cy: 103.12,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.545,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.905,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.865,
    cy: 72.76,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.985,
    cy: 42.4,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.625,
    cy: 1.92003,
    r: 1.265,
    fill: "#FBB979"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.255,
    cy: 32.28,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 82.88,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.895,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.775,
    cy: 82.88,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.415,
    cy: 42.4,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.295,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.815,
    cy: 143.6,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.815,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.695,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.695,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.575,
    cy: 184.08,
    r: 1.265,
    fill: "#9796F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.455,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.455,
    cy: 153.72,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.455,
    cy: 113.24,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.455,
    cy: 93,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.335,
    cy: 163.84,
    r: 1.265,
    fill: "#2C2C41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.0951,
    cy: 173.96,
    r: 1.265,
    fill: "#9796F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.0951,
    cy: 184.08,
    r: 1.265,
    fill: "#2C2C41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnoDots);
export default __webpack_public_path__ + "static/media/techno_dots.f7aab4194ef91bd9c1a3f85c88f92f30.svg";
export { ForwardRef as ReactComponent };